import {
  DateField,
  type NonAttendanceApplicationProperties,
} from '@/components/AbsenceApplication/types';
import { addDays } from '@/utils/date';

interface Params {
  properties: NonAttendanceApplicationProperties;
  calendarField: DateField | null;
  fromValue: Date;
  toValue: Date | null;
}

interface CalendarRange {
  filledDate: Date | null;
  outlinedDate?: Date;
  minDate: Date;
  maxDate: Date;
}

export const useAbsenceCalendarRange = ({
  properties,
  calendarField,
  fromValue,
  toValue,
}: Params): CalendarRange => {
  const { validPeriod, periodLimitInDays } = properties;
  const validPeriodStart = new Date(validPeriod.from);
  const validPeriodEnd = new Date(validPeriod.to);
  const isPickingFrom = calendarField === DateField.From;
  const showBothDates = !isPickingFrom && toValue !== null;
  const maxAbsenceDate = addDays(fromValue, periodLimitInDays - 1);

  return {
    filledDate: showBothDates ? toValue : fromValue,
    outlinedDate: showBothDates ? fromValue : undefined,
    minDate: isPickingFrom ? validPeriodStart : fromValue,
    maxDate: isPickingFrom
      ? validPeriodEnd
      : new Date(Math.min(maxAbsenceDate.getTime(), validPeriodEnd.getTime())),
  };
};
